import { ReactElement, useState, useEffect } from 'react';
import { Field } from 'formik';
import FieldWrapper from 'components/Form/FieldWrapper';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { LABEL_POSITIONS } from '../../../../../components/Form/_constants';
import { getHospitals } from './_api';
import { FORM_KEYS } from '../../_constants';

/**
 * Dropdown with active UPMC hospitals
 * @returns {ReactElement} Contextualized Dropdown Field Component
 */
const HospitalDropdown = ({ sx, labelPosition }) => {
	const [hospitalOptions, setHospitalOptions] = useState([]);
	useEffect(() => {
		getHospitals().then(payload => setHospitalOptions(payload));
	}, []);
	return (
		<Field name={FORM_KEYS.HOSPITAL_AFFILIATION}>
			{({ field, meta }) => (
				<FieldWrapper
					name={FORM_KEYS.HOSPITAL_AFFILIATION}
					label={'Select Hospital Affiliation'}
					meta={meta}
					additionalProps={{
						labelPosition: labelPosition
							? labelPosition
							: LABEL_POSITIONS.TOP,
					}}
					hideErrorMessage
				>
					<FormControl
						sx={sx}
						error={meta.touched && meta.error}
						required
						variant='filled'
					>
						<InputLabel
							id={FORM_KEYS.HOSPITAL_AFFILIATION + '__label'}
						>
							Hospital Affiliation
						</InputLabel>
						<Select
							id={FORM_KEYS.HOSPITAL_AFFILIATION}
							error={meta.touched && meta.error}
							fullWidth
							label='Hospital Affiliation'
							labelId={FORM_KEYS.HOSPITAL_AFFILIATION + '__label'}
							name={FORM_KEYS.HOSPITAL_AFFILIATION}
							onBlur={field.onBlur}
							onChange={field.onChange}
							value={field.value}
							variant='filled'
						>
							{hospitalOptions.map(hospital => (
								<MenuItem
									key={hospital.Key}
									value={hospital.Value}
								>
									{hospital.Value}
								</MenuItem>
							))}
						</Select>
						<FormHelperText>
							{meta.touched && meta.error ? meta.error : ' '}
						</FormHelperText>
					</FormControl>
				</FieldWrapper>
			)}
		</Field>
	);
};

export { HospitalDropdown };
